import { Blueprint, BlueprintPreviewMap } from 'dashboard/models/blueprint';
import { BlueprintsActions, BlueprintsActionType } from 'dashboard/redux/actions/blueprints';

export interface BlueprintsState {
  blueprints: Blueprint[];
  blueprintPreviews: BlueprintPreviewMap;
}

export const initialState: BlueprintsState = {
  blueprints: [],
  blueprintPreviews: {},
};

export default function (
  state: BlueprintsState = initialState,
  action: BlueprintsActions,
): BlueprintsState {
  switch (action.type) {
    case BlueprintsActionType.SetBlueprints: {
      return {
        ...state,
        blueprints: action.payload.blueprints,
      };
    }

    case BlueprintsActionType.AddBlueprints: {
      return {
        ...state,
        blueprints: [...state.blueprints, ...action.payload.blueprints],
      };
    }

    case BlueprintsActionType.SetBlueprintPreview: {
      return {
        ...state,
        blueprintPreviews: {
          ...state.blueprintPreviews,
          [action.payload.blueprintKey]: action.payload.preview,
        },
      };
    }

    default:
      return state;
  }
}
